/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { AltRoute, Close, Download } from "@mui/icons-material";
import { LogOut, User, Bell, AlertCircle, AlertTriangle, Home, UserPlus, Settings } from "feather-icons-react";
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "../../store/slices/LoginSlice";
import { SelectSideBarToggles, sideBarsToggleDispatch } from "../../store/slices/commonFunctionSlice";
import { axiosInstance } from "../../utils/commonInstance";
import { showToast } from "../../hooks/showToast";
import axios from "axios";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import NotAccessibleIcon from "@mui/icons-material/NotAccessible";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { selectRoleRights } from "../../store/slices/roleRightsSlice";
import { selectDashboardData } from "../../store/slices/dashBoardSlice";

const userId = localStorage.getItem("user_id");
const token = localStorage.getItem("accessToken");

window.Pusher = Pusher;
const echo = new Echo({
  broadcaster: "reverb",
  key: "uymf9unflbmhdwvfihe0",
  wsHost: process.env.REACT_APP_WEBSHOCKET_URL,
  wsPort: 443,
  wssPort: 443,
  forceTLS: true,
  enabledTransports: ["ws", "wss"],
  authEndpoint: `${process.env.REACT_APP_BACKEND_BASE_URL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  },
});

const HeaderLayout = ({ title }) => {
  const dispatch = useDispatch();
  const [notificationData, setNotificationData] = useState([]);
  const sidebarToggle = useSelector(SelectSideBarToggles);
  const [roleRightsData, setRoleRightsData] = useState([]);
  const { setValue } = useForm({});
  const location = useLocation();

  const dashBoardData = useSelector(selectDashboardData);
  const rightsData = useSelector(selectRoleRights);
  useEffect(() => {
    if (rightsData?.length) {
      setRoleRightsData(rightsData);
      rightsData.forEach((right) => setValue(right, true));
    }
  }, [rightsData, setValue]);

  const handleSidebarToggle = () => {
    dispatch(sideBarsToggleDispatch(!sidebarToggle));
  };

  const fetchNotificationReport = async () => {
    try {
      const response = await axiosInstance.get("web/getnotificationreport");
      if (!response.data.error) {
        setNotificationData(response.data.data);
        return { success: true };
      } else {
        // showToast("Export report failed. Please try again.", "error");
        return { success: false };
      }
    } catch (error) {
      showToast(error.message, "error");
      return { success: false };
    }
  };

  const handleAlertEvent = async (event) => {
    if (event?.web_hook !== true) {
      await fetchNotificationReport();
    }

    if (event?.web_hook === true) {
      const result = await fetchNotificationReport();
      if (result.success) {
        showToast(event?.message, "success");
      }
    } else {
      showToast(event?.message, "error");
    }
  };

  const registerChannel = (channelName, isPrivate = false) => {
    const channel = isPrivate ? echo.private(channelName) : echo.channel(channelName);
    channel.listen(".alert.new", handleAlertEvent);
    return channelName;
  };

  const cleanupChannels = (channelNames = []) => {
    channelNames.forEach((name) => echo.leave(name));
  };

  useEffect(() => {
    const channelsToListen = [registerChannel("alerts"), registerChannel(`report-status.${userId}`, true)];

    return () => {
      cleanupChannels(channelsToListen);
    };
  }, []);

  useEffect(() => {
    fetchNotificationReport();
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand navbar-light navbar-bg">
        <NavLink
          className="sidebar-toggle js-sidebar-toggle"
          onClick={() => {
            handleSidebarToggle();
          }}
        >
          <i className="hamburger align-self-center"></i>
        </NavLink>
        <p className="mb-0 fw-bold text-dark">{title}</p>
        <div className="navbar-collapse collapse">
          <ul className="navbar-nav navbar-align">
            <li className="nav-item dropdown">
              <NavLink className="nav-icon dropdown-toggle" to="/notification" id="alertsDropdown" data-bs-toggle="dropdown">
                <div className="position-relative">
                  <Bell className="align-middle" />
                  <span className="indicator">{notificationData?.Today?.length}</span>
                </div>
              </NavLink>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0 scrollable-dropdown" aria-labelledby="alertsDropdown">
                <div className="dropdown-menu-header">{notificationData?.Today?.length} New Notifications</div>
                <div className="list-group">
                  <NavLink href="#" className="list-group-item">
                    <div className="text-dark">Today</div>
                    {notificationData.Today?.map((ele, index) => (
                      <div className="row g-0 align-items-center" key={ele?.id}>
                        <div className="col-2">
                          {ele?.alert_type === "fire" ? (
                            // <WarningAmberIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img src="/assets/img/image_2024_06_27T06_32_29_806Z.png" alt="" height="25px" width="auto" />
                          ) : ele?.alert_type === "trespassing" ? (
                            // <NotAccessibleIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img
                              src="/assets/img/image_2024_06_27T06_34_03_181Z.png"
                              style={{
                                filter: "brightness(0) saturate(100%) invert(22%) sepia(100%) saturate(5043%) hue-rotate(0deg) brightness(100%) contrast(107%)",
                                height: "25px",
                                width: "auto",
                              }}
                            />
                          ) : ele?.alert_type === "panic mode" ? (
                            <WarningAmberIcon fontSize="small" style={{ color: "#dc3545" }} />
                          ) : (
                            <Download fontSize="small" style={{ color: "#dc3545" }} />
                          )}
                        </div>
                        <div className="col-10">
                          <>
                            <div className="text-muted small mt-1">
                              <NavLink to={!roleRightsData?.includes("exportreport.view") ? null : ele?.alert_type === "fire" ? "/getfire" : ele?.alert_type === "trespassing" ? "/getTrespassing" : ele?.alert_type === "panic mode" ? "/getpanicmode" : ele?.alert_type === "export" ? "/export-report" : "/dashboard"}>Alert Message: {ele?.alert_message}</NavLink>
                              <div>Alert Type: {ele?.alert_type}</div>
                            </div>
                            <div className="text-muted small mt-1">{ele?.alert_created_time}</div>
                          </>
                        </div>
                      </div>
                    ))}
                  </NavLink>

                  <NavLink href="#" className="list-group-item">
                    <div className="text-dark">Yesterday</div>
                    {notificationData.Yesterday?.map((ele, index) => (
                      <div className="row g-0 align-items-center" key={ele?.id}>
                        <div className="col-2">
                          {ele?.alert_type === "fire" ? (
                            // <LocalFireDepartmentIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img src="/assets/img/image_2024_06_27T06_32_29_806Z.png" alt="" height="25px" width="auto" />
                          ) : ele?.alert_type === "trespassing" ? (
                            // <NotAccessibleIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img
                              src="/assets/img/image_2024_06_27T06_34_03_181Z.png"
                              style={{
                                filter: "brightness(0) saturate(100%) invert(22%) sepia(100%) saturate(5043%) hue-rotate(0deg) brightness(100%) contrast(107%)",
                                height: "25px",
                                width: "auto",
                              }}
                            />
                          ) : ele?.alert_type === "panic mode" ? (
                            <WarningAmberIcon fontSize="small" style={{ color: "#dc3545" }} />
                          ) : (
                            <Download fontSize="small" style={{ color: "#dc3545" }} />
                          )}
                        </div>
                        <div className="col-10">
                          <>
                            <div className="text-muted small mt-1">
                              <NavLink to={!roleRightsData?.includes("exportreport.view") ? null : ele?.alert_type === "fire" ? "/getfire" : ele?.alert_type === "trespassing" ? "/getTrespassing" : ele?.alert_type === "panic mode" ? "/getpanicmode" : ele?.alert_type === "export" ? "/export-report" : "/dashboard"}>Alert Message: {ele?.alert_message}</NavLink>
                              <div>Alert Type: {ele?.alert_type}</div>
                            </div>
                            <div className="text-muted small mt-1">{ele?.alert_created_time}</div>
                          </>
                        </div>
                      </div>
                    ))}
                  </NavLink>

                  <NavLink href="#" className="list-group-item">
                    <div className="text-dark">Two Days Ago</div>
                    {notificationData.TwoDaysAgo?.map((ele, index) => (
                      <div className="row g-0 align-items-center" key={ele?.id}>
                        <div className="col-2">
                          {ele?.alert_type === "fire" ? (
                            // <LocalFireDepartmentIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img src="/assets/img/image_2024_06_27T06_32_29_806Z.png" alt="" height="25px" width="auto" />
                          ) : ele?.alert_type === "trespassing" ? (
                            // <NotAccessibleIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img
                              src="/assets/img/image_2024_06_27T06_34_03_181Z.png"
                              style={{
                                filter: "brightness(0) saturate(100%) invert(22%) sepia(100%) saturate(5043%) hue-rotate(0deg) brightness(100%) contrast(107%)",
                                height: "25px",
                                width: "auto",
                              }}
                            />
                          ) : ele?.alert_type === "panic mode" ? (
                            <WarningAmberIcon fontSize="small" style={{ color: "#dc3545" }} />
                          ) : (
                            <Download fontSize="small" style={{ color: "#dc3545" }} />
                          )}
                        </div>
                        <div className="col-10">
                          <>
                            <div className="text-muted small mt-1">
                              <NavLink to={!roleRightsData?.includes("exportreport.view") ? null : ele?.alert_type === "fire" ? "/getfire" : ele?.alert_type === "trespassing" ? "/getTrespassing" : ele?.alert_type === "panic mode" ? "/getpanicmode" : ele?.alert_type === "export" ? "/export-report" : "/dashboard"}>Alert Message: {ele?.alert_message}</NavLink>
                              <div>Alert Type: {ele?.alert_type}</div>
                            </div>
                            <div className="text-muted small mt-1">{ele?.alert_created_time}</div>
                          </>
                        </div>
                      </div>
                    ))}
                  </NavLink>

                  <NavLink href="#" className="list-group-item">
                    <div className="text-dark">One Week Ago</div>
                    {notificationData.OneWeekAgo?.map((ele, index) => (
                      <div className="row g-0 align-items-center" key={ele?.id}>
                        <div className="col-2">
                          {ele?.alert_type === "fire" ? (
                            // <LocalFireDepartmentIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img src="/assets/img/image_2024_06_27T06_32_29_806Z.png" alt="" height="25px" width="auto" />
                          ) : ele?.alert_type === "trespassing" ? (
                            // <NotAccessibleIcon
                            //   fontSize="small"
                            //   style={{ color: "#dc3545" }}
                            // />
                            <img
                              src="/assets/img/image_2024_06_27T06_34_03_181Z.png"
                              style={{
                                filter: "brightness(0) saturate(100%) invert(22%) sepia(100%) saturate(5043%) hue-rotate(0deg) brightness(100%) contrast(107%)",
                                height: "25px",
                                width: "auto",
                              }}
                            />
                          ) : ele?.alert_type === "panic mode" ? (
                            <WarningAmberIcon fontSize="small" style={{ color: "#dc3545" }} />
                          ) : (
                            <Download fontSize="small" style={{ color: "#dc3545" }} />
                          )}
                        </div>
                        <div className="col-10">
                          <>
                            <div className="text-muted small mt-1">
                              <NavLink to={!roleRightsData?.includes("exportreport.view") ? null : ele?.alert_type === "fire" ? "/getfire" : ele?.alert_type === "trespassing" ? "/getTrespassing" : ele?.alert_type === "panic mode" ? "/getpanicmode" : ele?.alert_type === "export" ? "/export-report" : "/dashboard"}>Alert Message: {ele?.alert_message}</NavLink>
                              <div>Alert Type: {ele?.alert_type}</div>
                            </div>
                            <div className="text-muted small mt-1">{ele?.alert_created_time}</div>
                          </>
                        </div>
                      </div>
                    ))}
                  </NavLink>
                </div>
                {/* <div className="dropdown-menu-footer">
                  <NavLink href="#" className="text-muted">
                    Show all notifications
                  </NavLink>
                </div> */}
              </div>
            </li>
            <li className="nav-item dropdown">
              <NavLink className="nav-icon dropdown-toggle d-inline-block d-sm-none" href="#" data-bs-toggle="dropdown">
                <User className="align-middle" />
              </NavLink>

              <NavLink className="nav-link dropdown-toggle d-none d-sm-inline-block" href="#" data-bs-toggle="dropdown">
                {/* <img
                  src="/assets/img/avatars/avatar.jpg"
                  className="avatar img-fluid rounded me-1"
                  alt="Charles Hall"
                /> */}
                <User />
                <span className="text-dark">{dashBoardData?.username}</span>
              </NavLink>
              <div className="dropdown-menu dropdown-menu-end">
                {/* <NavLink className="dropdown-item" href="pages-profile.html">
                  <User className="align-middle me-1" />
                  My Profile
                </NavLink>
                <div className="dropdown-divider"></div> */}
                <NavLink
                  onClick={() => {
                    localStorage.clear();
                    dispatch(signOut());
                  }}
                  to="/"
                  className="dropdown-item"
                >
                  <LogOut className="align-middle me-1" />
                  Log out
                </NavLink>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default HeaderLayout;
